// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.sidebar {
  position: fixed;
  top: 0;
  left: -320px;
  width: 320px;
  height: 100%;
  display: flex;              /* VAŽNO */
  flex-direction: column;     /* VAŽNO */
  overflow: hidden;           /* ne daj da unutrašnji elementi “iscure” van */
}
.sidebar.open { left: 0; }

/* Gornji sadržaj zauzima prostor iznad footera; ako je dugačak, scrolla se */
.sidebar-content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;           /* scroll unutar sidebar-a, footer ostaje fiksno dolje */
  padding-bottom: 0.5rem;     /* malo lufta iznad footera */
}

/* Footer na dnu */
.sidebar-footer {
  margin-top: auto;           /* gura footer na dno */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
}

.sidebar-footer img {
  max-width: 100%;
  height: auto;
}


.logo-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 1rem;
  text-align: center;
}

/* Samo Revicon logo */
.rev-logo {
  width: 70px;
  height: 64px; /* neka se sama prilagodi */
}

/* Samo Jafis logo */
.jafis-logo {
  width: 90px;  /* širi vodoravni */
  height: 36px;  /* neka se sama prilagodi */
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;          /* razmak između ikone i teksta */
  color: white;
  text-decoration: none;
  padding: 0.7rem 1rem;
  border-radius: 8px;
  transition: background-color 0.3s;
}

.menu-icon {
  width: 20px;   /* veličina ikone */
  height: 20px;
  object-fit: contain;
}


.title {
  font-size: 1.8rem;
  font-weight: bold;
}

.menu-section {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 1rem;
}


.menu-item:hover {
  background-color: #34495e;
}

.primary-box {
  background-color: #1abc9c;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
}

.primary-box:hover {
  background-color: #16a085;
}



.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.4);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
  z-index: 999;
}

.sidebar-overlay.show {
  opacity: 1;
  visibility: visible;
}

@media (min-width: 768px) {
  .sidebar {
    left: 0;
  }

  .sidebar-overlay {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa,eAAe,UAAU;EACtC,sBAAsB,MAAM,UAAU;EACtC,gBAAgB,YAAY,+CAA+C;AAC7E;AACA,gBAAgB,OAAO,EAAE;;AAEzB,6EAA6E;AAC7E;EACE,SAAO;EACP,aAAa;EACb,gBAAgB,YAAY,wDAAwD;EACpF,sBAAsB,MAAM,6BAA6B;AAC3D;;AAEA,kBAAkB;AAClB;EACE,gBAAgB,YAAY,uBAAuB;EACnD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY,EAAE,2BAA2B;AAC3C;;AAEA,oBAAoB;AACpB;EACE,WAAW,GAAG,mBAAmB;EACjC,YAAY,GAAG,2BAA2B;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,WAAW,iCAAiC;EACrD,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW,IAAI,mBAAmB;EAClC,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;AACX;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,OAAO;EACT;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: -320px;\n  width: 320px;\n  height: 100%;\n  display: flex;              /* VAŽNO */\n  flex-direction: column;     /* VAŽNO */\n  overflow: hidden;           /* ne daj da unutrašnji elementi “iscure” van */\n}\n.sidebar.open { left: 0; }\n\n/* Gornji sadržaj zauzima prostor iznad footera; ako je dugačak, scrolla se */\n.sidebar-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;           /* scroll unutar sidebar-a, footer ostaje fiksno dolje */\n  padding-bottom: 0.5rem;     /* malo lufta iznad footera */\n}\n\n/* Footer na dnu */\n.sidebar-footer {\n  margin-top: auto;           /* gura footer na dno */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 12px;\n}\n\n.sidebar-footer img {\n  max-width: 100%;\n  height: auto;\n}\n\n\n.logo-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 1rem;\n  text-align: center;\n}\n\n/* Samo Revicon logo */\n.rev-logo {\n  width: 70px;\n  height: 64px; /* neka se sama prilagodi */\n}\n\n/* Samo Jafis logo */\n.jafis-logo {\n  width: 90px;  /* širi vodoravni */\n  height: 36px;  /* neka se sama prilagodi */\n}\n\n.menu-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;          /* razmak između ikone i teksta */\n  color: white;\n  text-decoration: none;\n  padding: 0.7rem 1rem;\n  border-radius: 8px;\n  transition: background-color 0.3s;\n}\n\n.menu-icon {\n  width: 20px;   /* veličina ikone */\n  height: 20px;\n  object-fit: contain;\n}\n\n\n.title {\n  font-size: 1.8rem;\n  font-weight: bold;\n}\n\n.menu-section {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  gap: 1rem;\n}\n\n\n.menu-item:hover {\n  background-color: #34495e;\n}\n\n.primary-box {\n  background-color: #1abc9c;\n  font-weight: bold;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.3);\n}\n\n.primary-box:hover {\n  background-color: #16a085;\n}\n\n\n\n.sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0,0,0,0.4);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease;\n  z-index: 999;\n}\n\n.sidebar-overlay.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n@media (min-width: 768px) {\n  .sidebar {\n    left: 0;\n  }\n\n  .sidebar-overlay {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
